import { Link, useLocation } from 'react-router-dom'

export type StrategyView = 'landscape' | 'roadmap' | 'progress'

export function StrategyViewNavigation({ current }: { current: StrategyView }) {
  const location = useLocation()
  const view = current === 'progress' && location.pathname === '/strategy' ? 'progress' : current
  return <nav className="studio-lenses strategy-view-navigation" aria-label="Strategy & Roadmap views">
    <Link to="/strategy" aria-current={view === 'landscape' ? 'page' : undefined}>Strategy</Link>
    <Link to="/roadmap" aria-current={view === 'roadmap' ? 'page' : undefined}>Roadmap</Link>
    <Link to="/strategy?lens=progress" aria-current={view === 'progress' ? 'page' : undefined}>Progress</Link>
  </nav>
}
